export default "__VITE_ASSET__BVzSs6ol__"